<template>
  <div class="content">
    <div class="title-box">
      <span class="back-title">EVENTS</span>
      <span class="fron-title">信息资讯</span>
    </div>
    <div class="swiper box">
      <a-carousel autoplay easing="fade" v-if="imgList.length">
        <div
          v-for="item in imgList"
          :key="item.contentCode"
          @click="goNewsInfo(item.contentCode)"
        >
          <!-- 'http://10.10.152.115'+ -->
          <img class="img syxxzx" :src="item.imgUrl" />
          <p class="pname">{{ item.contentTitle }}</p>
        </div>
      </a-carousel>
    </div>
    <div class="more box">
      <div
        style="
          display: inline-flex;
          align-items: center;
          width: 440px;
        "
      >
        <div
          v-for="item in list"
          :key="item.key"
          class="box tab"
          @mouseenter="changeTag(item)"
          @click="
            pushRouter(
              `/announcement?moduleCode=${item.code}&name=${item.name}&linkname=${item.name}`
            )
          "
          :style="
            item === target &&
            'border-bottom: 2px solid rgba(203, 180, 134, 1); color: #000;'
          "
        >
          {{ item.name }}
        </div>
        <!-- <div class="box tab video" style="" @click="pushRouter('/player')">
          <img src="../../../assets/images/icon_notice_video.png" />
          视频点播
        </div> -->
      </div>
      <div>
        <div
          v-for="item in data"
          :key="item.contentCode"
          class="tab-box"
          @click="goDetail(item.contentCode)"
        >
          <div class="tab-text" :style="makeImportant(item)">
            {{ item.contentTitle }}
          </div>
          <div class="tab-date" v-if="String(item.createTime).length === 10">
            {{ item.createTime }}
          </div>
          <div class="tab-date" v-else>
            {{ String(item.createTime).split(" ")[0] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const data = [
  { title: "入境日本政策变更", date: "2021-03-08" },
  { title: "省外事服务中心领导慰问中心患病员工", date: "2021-03-08" },
  { title: "表彰慰问外企员工，宣传做好疫情防控", date: "2021-03-08" },
  { title: "外交部领事司领事认证工作调研组来闽调", date: "2021-03-08" },
];
import {
  getSwiper,
  getSwipeDetail,
  getAnnounce,
  getWork,
  getRecruitment,
  getPlayer,
  getInfoTitle,
} from "@/api/homeIndex.js";
import { getFileDetails } from "@/api/file.js";
import { getPic, getContentCode } from "@/api/service.js";
export default {
  name: "sider-content-02",
  data() {
    return {
      list: [],
      data,
      target: "",
      imgList: [],
    };
  },
  created() {
    // this.getImgs();
    this.getNewImgs();
    getInfoTitle().then((res) => {
      res.data.records.forEach((e) => {
        this.list.push({
          name: e.moduleName,
          code: e.moduleCode,
          contentECount: e.contentECount,
          moduleClass: e.moduleClass,
        });
      });
      this.target = this.list[0] || "";
      this.getInfo();
    });
  },
  methods: {
    makeImportant(item) {
      const a = ["RES4CBFFB55603A74C", "RES1D147D32DE33B94"]; //需要加红的内容
      const index = a.indexOf(item.contentCode);
      const style = index > -1 ? "font-weight:700;" : "";
      // const style=''
      return style;
    },
    // 获取首页轮播图
    async getImgs() {
      const res = await getSwiper();
      const records = this._.get(res, "data.records", []);
      this.imgList = JSON.parse(JSON.stringify([]));
      let code = [],
        appCode,
        tenantCode,
        picName;
      for (let i of records) {
        const pic = await getSwipeDetail(i.picCode, i.tenantCode);
        this.imgList.push({
          picName: i.picName,
          picFileCode: this._.get(
            pic,
            "data.contentPicFileDtoList.0.fileCode",
            ""
          ),
          fileObj: {},
        });
        code.push(this._.get(pic, "data.contentPicFileDtoList.0.fileCode", ""));
        appCode = this._.get(pic, "data.appCode", "");
        tenantCode = this._.get(pic, "data.tenantCode", "");
      }
      let img = await getFileDetails(appCode, tenantCode, code);
      for (let i = 0; i < this.imgList.length; i++) {
        if (!img.data) {
          return;
        }
        Object.values(img.data).forEach((item) => {
          if (item.fileCode === this.imgList[i].picFileCode) {
            this.imgList[i].fileObj = item;
          }
        });
      }
    },
    //获取图片新闻
    async getNewImgs() {
      const ret = await getContentCode("RES13147272E49B34E");
      console.log("图片轮播新的接口", ret);
      const ip =
        process.env.NODE_ENV == "production" ? "" : "http://www.ffasc.cn";
      this.imgList = ret.data.records.map((e) => {
        return {
          ...e,
          imgUrl: ip + e.contentLogo,
        };
      });
    },
    // 新闻详情
    goNewsInfo(contentCode){
      this.pushRouter(`/guide?type=contentNews&contentCode=${contentCode}&linkname=新闻轮博/详情`)
    },
    // 获取通知公告
    getInfo() {
      let index = this.list.indexOf(this.target) || 0;
      const fns = [getAnnounce(), getWork(), getRecruitment()];
      fns[index].then((res) => {
        this.data = this._.get(res, "data.records", []);
      });
    },
    changeTag(val) {
      this.target = val;
      this.getInfo();
    },
    goDetail(contentCode) {
      const name = this.list.find((item) => item === this.target).name;
      const url = `/guide?contentCode=${contentCode}&linkname=${name}/详情`;
      this.pushRouter(url);
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  margin-bottom: 80px;
}
.box {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
}
.swiper {
  width: 640px;
  height: 384px;
  margin-right: 61px;
}
.img {
  width: 640px;
  height: 384px;
}
.more {
  width: 439px;
  height: 384px;
}
.tab {
  width: 80px;
  height: 20px;
  padding-bottom: 40px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  // line-height: 41px;
}
.video:hover {
  background-color: #bb8e35;
}
.video {
  background: #cbb486;
  border-radius: 4px;
  color: white;
  text-align: center;
  padding: 0px;
  margin-top: -9px;
  width: 110px;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  img {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }
}
.tab:not(:last-of-type) {
  margin-right: 20px;
}
.tab-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 28px 0 32px 0;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  cursor: pointer;
}
.tab-text {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3d4652;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 800px;
  &:hover {
    color: #cab484;
  }
}
.tab-date {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bcbec0;
  width: 174px;
  text-align: right;
  &:hover {
    color: #cab484;
  }
}
/deep/ .ant-carousel .slick-slide {
  height: 384px;
}
/deep/ .ant-carousel .slick-dots-bottom {
  bottom: 30px;
  width: auto;
  min-width: 30px;
  right: 10px;
}
/deep/ .ant-carousel .slick-dots li button {
  width: 20px;
  height: 20px;
}
.title-box {
  padding-top: 28px;
  position: relative;
  padding-bottom: 15px;
}
.back-title {
  width: 392px;
  height: 63px;
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  line-height: 80px;
  /* opacity: 0.16; */
}
.fron-title {
  width: 112px;
  height: 28px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 52px;
}
.pname {
  position: absolute;
  z-index: 999;
  font-size: 16px;
  color: white;
  bottom: -13px;
  text-align: left;
  width: 100%;
  padding-left: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeIndex/siderContent02.vue